var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-img',{attrs:{"src":_vm.src,"max-width":_vm.column.max_width,"max-height":_vm.column.max_height,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }